// Auto-generated by semantic-release - DO NOT EDIT
export const VERSION_INFO = {
  version: '1.83.0',
  buildDate: '2026-11-05T02:23:10.100Z',
  commitSha: '37c0e1a',
} as const

export type VersionInfo = typeof VERSION_INFO
